import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Link } from 'components/misc/Link'
import Dropdown from './Dropdown'
import classNames from 'classnames'
import styles from './styles/NavCategoryDropdown.css'
import * as analytics from 'lib/analytics'

const MenuItem = ({ label, desc, to, href, onClick }) => {
  const location = useLocation()
  const isActive = to && !to.includes('#') && location.pathname === to

  const handleClick = e => {
    analytics.event({ category: 'Nav Dropdown', action: label })
    if (onClick) onClick(e)
  }

  if (href) {
    return (
      <a href={href} target='_blank' rel='noopener noreferrer' className={styles.menuItem} onClick={handleClick}>
        <span className={styles.itemLabel}>{label}</span>
        <span className={styles.itemDesc}>{desc}</span>
      </a>
    )
  }

  return (
    <Link to={to} className={classNames(styles.menuItem, { [styles.menuItemActive]: isActive })} onClick={handleClick}>
      <span className={styles.itemLabel}>{label}</span>
      <span className={styles.itemDesc}>{desc}</span>
    </Link>
  )
}

const NavCategoryDropdown = ({ title, overviewTo, items, showDropdownTriangle = false }) => {
  const [open, setOpen] = useState(false)
  const close = () => setOpen(false)

  return (
    <div className={styles.wrapper}>
      <Dropdown
        open={open}
        setOpen={setOpen}
        title={title}
        ariaLabel={title}
        className={styles.dropdown}
        showTriangle={showDropdownTriangle}
      >
        <div className={styles.items}>
          {items.map(item => (
            <MenuItem key={item.label} {...item} onClick={close} />
          ))}
        </div>
        <Link to={overviewTo} className={styles.viewAll} onClick={close}>
          All {title} →
        </Link>
      </Dropdown>
    </div>
  )
}

export default NavCategoryDropdown
